import hyperHTML from 'hyperhtml';

const getClasses = (data) => {
  const classList = ['e-spinner'];

  if (data.size === 'table') {
    classList.push(`e-spinner-${data.size}`);
  }

  if (data.fullscreen) {
    classList.push('e-spinner-fullscreen');
  }

  return classList.join(' ');
};

const getProperSvgSize = (size) => {
  size = size === 'table' ? 'small' : size;

  const radius = { small: 40, medium: 42, large: 45 };
  const circleBase = `e-spinner-circle e-spinner-circle-${size} e-spinner-svg__circle_base`;
  const circle1 = `e-spinner-circle e-spinner-circle-${size} e-spinner-svg__circle_01 e-spinner-svg__circle_01-${size}`;
  const circle2 = `e-spinner-circle e-spinner-circle-${size} e-spinner-svg__circle_02 e-spinner-svg__circle_02-${size}`;
  const circle3 = `e-spinner-circle e-spinner-circle-${size} e-spinner-svg__circle_03 e-spinner-svg__circle_03-${size}`;

  const svgClass = `e-spinner-svg e-spinner-svg-${size}`;

  return hyperHTML.wire()`
    <svg class="${svgClass}" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle class=${circleBase} cx="50" cy="50" r=${radius[size]}/>
      <circle class=${circle1} cx="50" cy="50" r=${radius[size]}/>
      <circle class=${circle2} cx="50" cy="50" r=${radius[size]}/>
      <circle class=${circle3} cx="50" cy="50" r=${radius[size]}/>
    </svg>
  `;
};

export default (render, data) => {
  const text = hyperHTML.wire(data)`<span class="e-spinner__text">${data.text}</span>`;
  const spinnerSvg = getProperSvgSize(data.size);

  render`
    <div class="${getClasses(data)}">
      ${spinnerSvg}
      ${data.text ? text : ''}
    </div>
  `;
};
